"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PlatformModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const react_native_paper_1 = require("react-native-paper");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        backdrop: {
            backgroundColor: "rgba(0,0,0,0.4)",
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center'
        },
        dialog: {
            backgroundColor: THEME.CardBackground,
            borderRadius: size != 'sm' ? 4 : 4,
            padding: size != 'sm' ? 24 : 12,
            minWidth: size != 'sm' ? 480 : "95%",
            maxWidth: size != 'sm' ? "60%" : "95%",
            maxHeight: "84%"
        }
    });
};
function PlatformModal(props) {
    const styles = useStyles();
    return (props.usePaper
        &&
            (0, jsx_runtime_1.jsx)(react_native_paper_1.Modal, { contentContainerStyle: [styles.dialog, { alignSelf: 'center', maxWidth: 550 }], visible: props.isVisible, onDismiss: () => props.onDismiss(), children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: [{ pointerEvents: "auto" }], children: (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { children: props.children }) }) })
        ||
            (0, jsx_runtime_1.jsx)(react_native_1.Modal, { animationType: 'fade', transparent: true, visible: props.isVisible, style: { maxWidth: 550 }, onRequestClose: () => props.onDismiss(), children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: [{ pointerEvents: "box-only" }, styles.backdrop], onPress: () => props.onDismiss(), children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: [{ pointerEvents: "auto" }, styles.dialog], children: (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { children: props.children }) }) }) }));
}
